module.exports = __webpack_public_path__ + "img/default_av.a358597f.png";